export default __webpack_public_path__ + "static/media/google-play.3388f39b.webp";